export type MediaType = "movie" | "tv";

export type Region = "大陆" | "港台" | "欧美" | "日韩" | "其他";

export interface MediaItem {
  id: string;
  title: string;
  type: MediaType;
  cover: string;
  backdrop: string;
  year: number;
  region: Region;
  genres: string[];
  rating: number;
  duration: string;
  director: string;
  actors: string[];
  synopsis: string;
  storyline: string[];
  tags: string[];
  clicks: number;
  updatedAt: string;
}

export type NewsCategory = "电影资讯" | "电视剧资讯" | "行业动态";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  date: string;
  summary: string;
  content: string[];
  cover: string;
  tags: string[];
}

export const REGIONS: Region[] = ["大陆", "港台", "欧美", "日韩", "其他"];

export const GENRES: string[] = [
  "剧情",
  "喜剧",
  "动作",
  "科幻",
  "爱情",
  "悬疑",
  "犯罪",
  "动画",
  "奇幻",
  "战争",
  "历史",
  "冒险",
  "家庭",
];

export const NEWS_CATEGORIES: NewsCategory[] = [
  "电影资讯",
  "电视剧资讯",
  "行业动态",
];